import { HeaderImageStructure } from 'common/components';
import {
  BARNAUL,
  CHELYABINSK,
  CHEREPOVETS,
  IRKUTSK,
  KEMEROVO,
  KRASNOYARSK,
  KURSK,
  NOVOKUZNETSK,
  NOVOSIBIRSK,
  OMSK,
  ORENBURG,
  SAMARA,
  SURGUT,
  TOLYATTI,
  TYUMEN,
} from 'common/constants/region-codes';

export const METAL_ROOF_PATH = '/uslugi/gotovye-resheniya-pod-klyuch/krovlya-pod-zakaz/';

export const METAL_ROOF_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/metal-roof';

export const METAL_ROOF_CONSULTATION_TYPE = 'ROOF';

export const METAL_ROOF_ELEMENT_BLOCK_MAP: Record<string, string> = {
  'main-page': 'landingKrovlya',
  metallocherepica: 'landingKrovlyaMetallocherepica',
  profnastil: 'landingKrovlyaProfnastil',
  falcevaya: 'landingKrovlyaFalcevaya',
  'gibkaya-cherepitsa': 'landingKrovlyaGibkayaCherepitsa',
  ondulin: 'landingKrovlyaOndulin',
};

export const METAL_ROOF_LANDING_NAME = 'metal-roof';

export const METAL_ROOF_SERVICE_ID = '1764';

export const METAL_ROOF_STEP_LIST_WITH_MOUNTING = [
  {
    description:
      'Свяжемся с\u00A0вами и\u00A0подробно обсудим проект, ответим на\u00A0вопросы и\u00A0сделаем предварительный расчёт.',
    title: 'Оставьте заявку',
  },
  {
    description:
      'Согласуем финальную смету и\u00A0оформим договор\u00A0\u2014 оплатить можно в\u00A0магазине или онлайн.',
    title: 'Оформите договор',
  },
  {
    description: 'Доставим готовую кровлю в\u00A0удобный для вас день и\u00A0время.',
    title: 'Получите заказ',
  },
  {
    description:
      'Опытная бригада установит стропильную систему и\u00A0выполнит монтаж кровли\u00A0\u2014 уточните доступность услуги у\u00A0нашего менеджера.',
    title: 'Согласуйте монтаж',
  },
];

export const REGION_LIST_WITHOUT_SEAM_ROOFING = [
  SAMARA,
  TOLYATTI,
  KRASNOYARSK,
  IRKUTSK,
  TYUMEN,
  SURGUT,
  CHELYABINSK,
  ORENBURG,
  NOVOSIBIRSK,
  BARNAUL,
  CHEREPOVETS,
  KURSK,
  NOVOKUZNETSK,
  OMSK,
  KEMEROVO,
];

type MetalRoofheaderStructure = {
  img: HeaderImageStructure;
  bgColor: string;
  description: string;
  title: string;
};

export const METAL_ROOF_TYPE_NAME_MAP: Record<string, string> = {
  'main-page': 'Кровли на заказ',
  metallocherepica: 'Кровли из металлочерепицы',
  profnastil: 'Кровли из профнастила',
  falcevaya: 'Фальцевые кровли',
  'gibkaya-cherepitsa': 'Кровли из гибкой черепицы',
  ondulin: 'Кровли из ондулина',
};

export const METAL_ROOF_HEADER_MAP: Record<string, MetalRoofheaderStructure> = {
  'main-page': {
    bgColor: '#913300',
    description: 'Изготовим прочную кровлю любой сложности по\u00A0размерам вашей крыши',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/header-new-ld.jpg/header-new-ld.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/header-new-d.jpg/header-new-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/header-new-t.jpg/header-new-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/header-new-m.jpg/header-new-m.jpg`,
      alt: 'Кровли на заказ',
    },
    title: 'Кровли на\u00A0заказ',
  },
  metallocherepica: {
    bgColor: '#555D66',
    description:
      'Надёжный материал для нашего климата: отличается долговечностью, высоким качеством и\u00A0разнообразием цветов и\u00A0профилей',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/metallocherepica/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/metallocherepica/header-d.jpg/header-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/metallocherepica/header-t.jpg/header-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/metallocherepica/header-m.jpg/header-m.jpg`,
      alt: 'Кровли из металлочерепицы на заказ',
    },
    title: 'Кровли\nиз\u00A0металлочерепицы\nна\u00A0заказ',
  },
  profnastil: {
    bgColor: '#297B85',
    description:
      'Изготовим прочную кровлю по\u00A0доступной цене. Профнастил отлично подойдёт для покрытия больших площадей: цехов, складов, торговых центров, а\u00A0также для крыш коттеджей и\u00A0частных домов с\u00A0нестандартной геометрией.',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/profnastil/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/profnastil/header-d.jpg/header-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/profnastil/header-t.jpg/header-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/profnastil/header-m.jpg/header-m.jpg`,
      alt: 'Кровли из профнастила на заказ',
    },
    title: 'Кровли\nиз\u00A0профнастила\nна\u00A0заказ',
  },
  falcevaya: {
    bgColor: '#726676',
    description:
      'Материал идеально подходит для сложных форм крыш и\u00A0отделки фасадов, таких как дымовые трубы, вентиляционные каналы и\u00A0свесы кровли',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/falcevaya/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/falcevaya/header-d.jpg/header-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/falcevaya/header-t.jpg/header-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/falcevaya/header-m.jpg/header-m.jpg`,
      alt: 'Фальцевые кровли на заказ',
    },
    title: 'Фальцевые кровли\nна\u00A0заказ',
  },
  'gibkaya-cherepitsa': {
    bgColor: '#4F4D4E',
    description:
      'Гибкая черепица может подстраиваться под любую форму и\u00A0изгиб крыши. Она как хамелеон\u00A0\u2014 меняет свой цвет и\u00A0текстуру в\u00A0зависимости от\u00A0угла зрения',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/gibkaya-cherepitsa/header-ld.jpg/header-ld-2.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/gibkaya-cherepitsa/header-d.jpg/header-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/gibkaya-cherepitsa/header-t.jpg/header-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/gibkaya-cherepitsa/header-m.jpg/header-m.jpg`,
      alt: 'Кровли из гибкой черепицы на заказ',
    },
    title: 'Кровли из\u00A0гибкой\nчерепицы на\u00A0заказ',
  },
  ondulin: {
    bgColor: '#404C33',
    description:
      'Изготовим уникальную и\u00A0прочную кровлю из\u00A0ондулина по\u00A0размерам вашей крыши. Материал отлично изолирует звук, экологичен и\u00A0долговечен',
    img: {
      ldSrcSet: `${METAL_ROOF_CDN_PATH}/header/ondulin/header-ld.jpg/header-ld.jpg`,
      dSrcSet: `${METAL_ROOF_CDN_PATH}/header/ondulin/header-d.jpg/header-d.jpg`,
      tSrcSet: `${METAL_ROOF_CDN_PATH}/header/ondulin/header-t.jpg/header-t.jpg`,
      mSrcSet: `${METAL_ROOF_CDN_PATH}/header/ondulin/header-m.jpg/header-m.jpg`,
      alt: 'Кровли из ондулина на заказ',
    },
    title: 'Кровли из\u00A0ондулина\nна\u00A0заказ',
  },
};
